import * as PIXI from 'pixi.js'
import { Text } from 'pixi.js'

export default class objText {
    constructor(app, container) {
        this.app = app
        this.container = container

        this.theme = '' // 改行ありテーマテキスト（日本語用）
        this.selecttheme = '' // 改行なしテーマテキスト（セレクトボックス用・外国語用）
        this.jsonlist = ''

        this.txtSprite = null

        //フォントのリスト
        this.cstylelistja = [
            {
                dropShadow: true,
                dropShadowAngle: 0,
                dropShadowBlur: 12,
                dropShadowDistance: 0,
                fill: '#fff',
                fontSize: 60,
                fontFamily: ['BIZ UDMincho', 'serif'],
                fontWeight: 700,
                lineHeight: 70,
                padding: 15,
            },
            {
                dropShadow: true,
                dropShadowAngle: 0,
                dropShadowBlur: 12,
                dropShadowDistance: 0,
                fill: '#fff',
                fontSize: 60,
                fontFamily: ['Mochiy Pop One', 'sans-serif'],
                fontWeight: 400,
                padding: 15,
            },
            {
                dropShadow: true,
                dropShadowAngle: 0,
                dropShadowBlur: 12,
                dropShadowDistance: 0,
                fill: '#fff',
                fontSize: 60,
                fontFamily: ['Klee One', 'cursive'],
                fontWeight: 600,
                padding: 15,
            },
            {
                dropShadow: true,
                dropShadowAngle: 0,
                dropShadowBlur: 12,
                dropShadowDistance: 0,
                fill: '#fff',
                fontSize: 60,
                fontFamily: ['BIZ UDPGothic', 'sans-serif'],
                fontWeight: 700,
                padding: 15,
            },
            {
                dropShadow: true,
                dropShadowAngle: 0,
                dropShadowBlur: 12,
                dropShadowDistance: 0,
                fill: '#fff',
                fontSize: 60,
                fontFamily: ['Noto Serif JP', 'serif'],
                fontWeight: 600,
                padding: 15,
            },
            {
                dropShadow: true,
                dropShadowAngle: 0,
                dropShadowBlur: 12,
                dropShadowDistance: 0,
                fill: '#fff',
                fontSize: 60,
                fontFamily: ['Noto Sans JP', 'sans-serif'],
                fontWeight: 900,
                padding: 15,
            },
            {
                fill: '#fff',
                fontSize: 60,
                fontFamily: ['Noto Sans JP', 'sans-serif'],
                fontWeight: 100,
            },
        ]
        this.cstyle = this.cstylelistja[0]

        this.cstylelistother = [
            {
                breakWords: true,
                dropShadow: true,
                dropShadowAngle: 0,
                dropShadowBlur: 12,
                dropShadowDistance: 0,
                fill: '#fff',
                fontSize: 50,
                fontFamily: ['BIZ UDMincho', 'serif'],
                fontWeight: 700,
                padding: 15,
                lineHeight: 60,
                wordWrap: true,
                wordWrapWidth: 340,
            },
            {
                breakWords: true,
                dropShadow: true,
                dropShadowAngle: 0,
                dropShadowBlur: 12,
                dropShadowDistance: 0,
                fill: '#fff',
                fontSize: 50,
                fontFamily: ['Mochiy Pop One', 'sans-serif'],
                fontWeight: 400,
                padding: 15,
                wordWrap: true,
                wordWrapWidth: 340,
            },
            {
                breakWords: true,
                dropShadow: true,
                dropShadowAngle: 0,
                dropShadowBlur: 12,
                dropShadowDistance: 0,
                fill: '#fff',
                fontSize: 50,
                fontFamily: ['Klee One', 'cursive'],
                fontWeight: 600,
                padding: 15,
                wordWrap: true,
                wordWrapWidth: 340,
            },
            {
                breakWords: true,
                dropShadow: true,
                dropShadowAngle: 0,
                dropShadowBlur: 12,
                dropShadowDistance: 0,
                fill: '#fff',
                fontSize: 50,
                fontFamily: ['BIZ UDPGothic', 'sans-serif'],
                fontWeight: 700,
                letterSpacing: 2,
                padding: 15,
                wordWrap: true,
                wordWrapWidth: 340,
            },
            {
                breakWords: true,
                dropShadow: true,
                dropShadowAngle: 0,
                dropShadowBlur: 12,
                dropShadowDistance: 0,
                fill: '#fff',
                fontSize: 50,
                fontFamily: ['Noto Serif JP', 'serif'],
                fontWeight: 600,
                padding: 15,
                wordWrap: true,
                wordWrapWidth: 340,
            },
            {
                breakWords: true,
                dropShadow: true,
                dropShadowAngle: 0,
                dropShadowBlur: 12,
                dropShadowDistance: 0,
                fill: '#fff',
                fontSize: 50,
                fontFamily: ['Noto Sans JP', 'sans-serif'],
                fontWeight: 900,
                padding: 15,
                wordWrap: true,
                wordWrapWidth: 340,
            },
            {
                fill: '#fff',
                fontSize: 50,
                fontFamily: ['Noto Serif JP', 'sans-serif'],
                fontWeight: 100,
            },
        ]

        this.init()
    }

    init() {
        this.getFont()
        this.getData()
    }

    resetStyle() {
        this.cstyle = this.cstylelistja[0]
    }

    async getData() {
        const jsonUrl = `/oshigatari/_inc/parts/generator/data/charalist.json`
        const res = await fetch(jsonUrl)
        this.jsonlist = await res.json()
    }

    getFont() {
        this.setText()
        this.setFont()

        /* WebFont.load({
            google: {
                families: ['Noto+Sans+JP', 'Mochiy+Pop+One', 'Klee+One:wght@600', 'BIZ+UDMincho', 'Shippori+Antique+B1', 'Noto+Serif+JP', 'BIZ+UDMincho:wght@700'],
            },
            active: () => {
                //console.log('font loading 成功！！')

                this.setText()
                this.setFont()
            },
            inactive: () => {
                // フォント読み込み失敗時
                //console.log('font loading failed')
            },
        }) */
    }

    setText() {
        const selecttheme = document.getElementById('selecttheme')
        const selectthemebox = document.querySelector('.generator__theme__select')

        selecttheme.addEventListener('click', () => {
            selectthemebox.classList.add('-active')

            this.selectTxt()
        })
    }

    selectTxt() {
        const selecttheme = document.getElementById('selecttheme')
        const textitem = [...document.querySelectorAll('.generator__theme__item')]
        const selectthemebox = document.querySelector('.generator__theme__select')

        textitem.forEach((el) => {
            el.addEventListener('click', () => {
                //選択済みのテキストをリセット
                textitem.forEach((e) => {
                    e.classList.remove('-active')
                })

                const value = el.getAttribute('data-value')
                const theme = value.replace(/\\n/g, '\n')

                this.theme = theme
                this.selecttheme = el.textContent
                selecttheme.textContent = this.selecttheme

                el.classList.add('-active')
                selectthemebox.classList.remove('-active')

                this.removeSprite()
                this.getName()

                // OKボタンON
                const btnok = document.querySelector('.js-btn-paginate.-ok')
                btnok.classList.add('-active')
                this.activeController()
            })
        })
    }

    setFont() {
        const fontitem = [...document.querySelectorAll('.js-ques-font')]

        fontitem.forEach((el) => {
            el.addEventListener('click', () => {
                const font = el.getAttribute('data-font')

                if (document.documentElement.lang === 'ja') {
                    this.cstyle = this.cstylelistja[font]
                } else {
                    this.cstyle = this.cstylelistother[font]
                }

                this.setTxtKanji()
            })
        })
    }

    //テキスト漢字が変換されるように
    setTxtKanji() {
        this.txtSprite.alpha = 0
    
        setTimeout(() => {
            this.txtSprite.style.fontFamily = this.cstyle.fontFamily
            this.txtSprite.style.fontWeight = this.cstyle.fontWeight
        }, 50)
        setTimeout(() => {
            this.txtSprite.style.fontFamily = this.cstylelistja[6].fontFamily
            this.txtSprite.style.fontWeight = this.cstylelistja[6].fontWeight
        }, 180)
        setTimeout(() => {
            this.txtSprite.alpha = 1
            this.txtSprite.style.fontFamily = this.cstyle.fontFamily
            this.txtSprite.style.fontWeight = this.cstyle.fontWeight

            //this.txtSprite.style.fontWeight = 400
        }, 250)
    }

    //テキスト選択リセット
    resetSelect() {
        const selecttheme = document.getElementById('selecttheme')
        const textitem = [...document.querySelectorAll('.generator__theme__item')]

        selecttheme.textContent = 'テーマを選択してください'
        textitem.forEach((e) => {
            e.classList.remove('-active')
        })
    }

    //テキストがあれば削除する
    removeSprite() {
        if (this.txtSprite) {
            this.container.removeChild(this.txtSprite)
            delete this.txtSprite
        }
    }

    //テキストを選択しないと押せない
    activeController() {
        const controller = document.querySelector('.generator__ques.-theme')
        controller.classList.add('-oncontroller')
    }
    offController() {
        const controller = document.querySelector('.generator__ques.-theme')
        controller.classList.remove('-oncontroller')
    }

    //推し設定でcontainer作成
    setContainer() {
        this.container = new PIXI.Container()
        this.container.sortableChildren = true
        this.app.stage.addChild(this.container)

        this.getName()
    }

    getName() {
        const charaitem = [...document.querySelectorAll('.js-ques-chara')]

        charaitem.forEach((el) => {
            const charaid = el.getAttribute('data-index')

            if (charaid === MAIN.data.characterid) {
                const charanamitem = el.querySelector('.name')
                const charaname = charanamitem.textContent

                this.setFName(charaname)
            }
        })
    }

    setFName(charaname) {
        const name = charaname
        let style = Object.assign({}, this.cstyle)
        let theme = ''

        if (document.documentElement.lang === 'ja') {
            theme = this.theme.replace('〇〇', name)
        } else {
            style = Object.assign({}, this.cstylelistother[0])
            const namere = name.replace('·', ' ')
            theme = this.selecttheme.replace('〇〇', namere)
        }

        PIXI.TextMetrics.BASELINE_SYMBOL += 'あいうえお？'
        this.txtSprite = new Text(theme, new PIXI.TextStyle(style))

        let textWidth = this.txtSprite.width
        let textHeight = this.txtSprite.height

        this.txtSprite.pivot.x = textWidth / 2
        this.txtSprite.pivot.y = textHeight / 2

        this.txtSprite.x = this.app.renderer.width / 2
        this.txtSprite.y = this.app.renderer.height / 2

        this.txtSprite.zIndex = 2

        this.container.addChild(this.txtSprite)

        this.setPosition(this.txtSprite)
        this.setSize(this.txtSprite)

        this.setTxtKanji()
    }

    setPosition(text) {
        const positionitem = [...document.querySelectorAll('.js-ques-position')]
        const canvasW = this.app.renderer.width
        const canvasH = this.app.renderer.height
        const textW = this.txtSprite.width / 2
        const textH = this.txtSprite.height / 2

        let intervalId = null

        positionitem.forEach((el) => {
            //長押しで移動
            el.addEventListener('pointerdown', () => {
                const position = el.getAttribute('data-position')

                // 既存のインターバルがあればクリアする
                if (intervalId !== null) {
                    clearInterval(intervalId)
                }
                intervalId = setInterval(movePosition, 50)

                document.addEventListener(
                    'pointerup',
                    () => {
                        clearInterval(intervalId)
                        intervalId = null // インターバルIDをリセット
                    },
                    { once: true }
                )

                function movePosition() {
                    let newX = text.x
                    let newY = text.y

                    if (position === '1') {
                        newX -= 10
                    } else if (position === '2') {
                        newX += 10
                    } else if (position === '3') {
                        newY -= 10
                    } else if (position === '4') {
                        newY += 10
                    }

                    // 移動距離を制限
                    text.x = Math.max(textW - 100, Math.min(canvasW - textW + 100, newX))
                    text.y = Math.max(textH - 40, Math.min(canvasH - textH + 40, newY))
                }
            })
        })
    }

    setSize(text) {
        const sizeitem = [...document.querySelectorAll('.js-ques-size')]
        let intervalId = null

        sizeitem.forEach((el) => {
            //長押しでサイズ変更
            el.addEventListener('pointerdown', () => {
                const sizeid = el.getAttribute('data-size')

                // 既存のインターバルがあればクリアする
                if (intervalId !== null) {
                    clearInterval(intervalId)
                }
                intervalId = setInterval(scaleText, 70)

                document.addEventListener(
                    'pointerup',
                    () => {
                        clearInterval(intervalId)
                        intervalId = null // インターバルIDをリセット
                    },
                    { once: true }
                )

                function scaleText() {
                    let NewSX = text.scale.x
                    let NewSY = text.scale.y

                    if (sizeid === '0') {
                        NewSX *= 1.1
                        NewSY *= 1.1
                    } else {
                        NewSX *= 0.9
                        NewSY *= 0.9
                    }

                    // 拡大を制限
                    text.scale.x = Math.max(0.6, Math.min(2.5, NewSX))
                    text.scale.y = Math.max(0.6, Math.min(2.5, NewSY))
                }
            })
        })
    }
}
